import type { NavigationParams, NavigationResult } from 'types';

export const calculateNextRecordNavigation = (params: NavigationParams): NavigationResult => {
  const { recordId, data, savedNavigationState } = params;

  const relativeIndex = data?.items?.findIndex((item) => item.id === recordId) ?? 0;
  const currentAbsoluteIndex = savedNavigationState?.lastClickedRow?.absoluteIndex ?? 0;
  const totalRecords = data?.totalCount ?? 0;

  if (relativeIndex < data.items.length - 1) {
    const nextRecord = data.items[relativeIndex + 1];
    const nextAbsoluteIndex = currentAbsoluteIndex + 1;

    return {
      shouldNavigate: true,
      targetRecordId: nextRecord.id,
      navigationState: {
        id: nextRecord.id,
        relativeIndex: savedNavigationState?.lastClickedRow?.relativeIndex ?? 0,
        absoluteIndex: nextAbsoluteIndex,
      },
      isCrossPageNavigation: false,
    };
  }

  if (currentAbsoluteIndex < totalRecords - 1) {
    const nextAbsoluteIndex = currentAbsoluteIndex + 1;

    return {
      shouldNavigate: true,
      targetRecordId: recordId,
      navigationState: {
        id: recordId,
        relativeIndex: savedNavigationState?.lastClickedRow?.relativeIndex ?? 0,
        absoluteIndex: nextAbsoluteIndex,
      },
      isCrossPageNavigation: true,
    };
  }

  return {
    shouldNavigate: false,
    targetRecordId: recordId,
    navigationState: {
      id: recordId,
      relativeIndex: savedNavigationState?.lastClickedRow?.relativeIndex ?? 0,
      absoluteIndex: currentAbsoluteIndex,
    },
    isCrossPageNavigation: false,
  };
};

export const calculatePrevRecordNavigation = (params: NavigationParams): NavigationResult => {
  const { recordId, data, savedNavigationState } = params;

  const relativeIndex = data?.items?.findIndex((item) => item.id === recordId) ?? 0;
  const currentAbsoluteIndex = savedNavigationState?.lastClickedRow?.absoluteIndex ?? 0;

  if (relativeIndex > 0) {
    const prevRecord = data.items[relativeIndex - 1];
    const prevAbsoluteIndex = currentAbsoluteIndex - 1;

    return {
      shouldNavigate: true,
      targetRecordId: prevRecord.id,
      navigationState: {
        id: prevRecord.id,
        relativeIndex: savedNavigationState?.lastClickedRow?.relativeIndex ?? 0,
        absoluteIndex: prevAbsoluteIndex,
      },
      isCrossPageNavigation: false,
    };
  }

  if (currentAbsoluteIndex > 0) {
    const prevAbsoluteIndex = currentAbsoluteIndex - 1;

    return {
      shouldNavigate: true,
      targetRecordId: recordId,
      navigationState: {
        id: recordId,
        relativeIndex: savedNavigationState?.lastClickedRow?.relativeIndex ?? 0,
        absoluteIndex: prevAbsoluteIndex,
      },
      isCrossPageNavigation: true,
    };
  }

  return {
    shouldNavigate: false,
    targetRecordId: recordId,
    navigationState: {
      id: recordId,
      relativeIndex: savedNavigationState?.lastClickedRow?.relativeIndex ?? 0,
      absoluteIndex: currentAbsoluteIndex,
    },
    isCrossPageNavigation: false,
  };
};
